export const quoteState = {
  loading: false,
  response: null,
  error: false,
  quote: null,
};
